import React, { FC, useState } from 'react';
import { IData } from '.';
import Buttons from './Buttons';
import Range from './Range';
import Remarks from './Remarks';
import { ERANGE_MGMT_TYPES, ESIGNAL_REPORT_TYPE_VAL, ILocalRange } from 'redux/app/vessel/onboard/types';
import { ModalType } from '../Ranges';
import CNRRangeType from './CNRRangeType';

interface IEditModalProps {
    data: IData;
    setData: React.Dispatch<React.SetStateAction<IData>>;
    onCancel: () => void;
    onSubmit: (localRange?: ILocalRange) => void;
	dropdownType: ERANGE_MGMT_TYPES;
    signalReportType?: ESIGNAL_REPORT_TYPE_VAL;
}
const EditModal: FC<IEditModalProps> = ({ data,onCancel, onSubmit , setData, dropdownType, signalReportType }) => {
    const [rangeErrorMsg, setRangeErrorMsg] = useState('');
    const [remarksErrorMsg, setRemarksErrorMsg] = useState('');
    return (
        <>
			<h4 className='font-medium mb-1'>{data?.metric?.label}</h4>
            <Range 
                rangeErrorMsg={rangeErrorMsg}
                setRangeErrorMsg={setRangeErrorMsg}
                data={data}
                setData={setData}
            />
			{dropdownType === ERANGE_MGMT_TYPES.SIGNAL_REPORT ? (
                <CNRRangeType data={data} setData={setData} />
            ) : null}
            <Remarks data={data} setData={setData} remarksErrorMsg={remarksErrorMsg} />
            <Buttons
                setRangeErrorMsg={setRangeErrorMsg}
				signalReportType={signalReportType}
                btn1={
                    {
                        isVisible: true,
                        text: 'Save',
                        className: 'text-secondary'
                    }
                }
                btn2={{
                    isVisible: true,
                    text: 'Cancel'
                }}
                modalType={ModalType.Edit}
				dropdownType={dropdownType}
                data={data}
                onCancel={onCancel}
                onSubmit={(localRange) => {
                    if (!data.remarks) {
                        setRemarksErrorMsg('Remarks are required.');
                        return;
                    }
                    onSubmit(localRange);
                }}
            />
        </>
    );
};

export default EditModal;
